import { Opaque } from '@sparkdotfi/common-universal'
import { AnyRouter, linkOptions, RegisteredRouter, LinkProps as TanstackLinkProps } from '@tanstack/react-router'
import { MouseEventHandler, ReactNode } from 'react'

interface LinkBase {
  className?: string
  onClick?: MouseEventHandler<HTMLElement>
  'data-testid'?: string
}

export interface ExternalLink extends LinkBase {
  external: true
  to: string
  children?: ReactNode
}

// @note: Fix LegacyRef -> Ref: remove string from ref type in activeProps/inactiveProps
type WithoutStringRef<T> = T extends object ? { [K in keyof T]: K extends 'ref' ? Exclude<T[K], string> : T[K] } : T
type LinkProps = {
  [K in keyof TanstackLinkProps]: K extends 'activeProps' | 'inactiveProps'
    ? WithoutStringRef<TanstackLinkProps[K]>
    : TanstackLinkProps[K]
}

export type InternalLink = Opaque<LinkProps, 'InternalLink'> & LinkBase & { external?: false }
export function InternalLink<const TOptions, TRouter extends AnyRouter = RegisteredRouter>(
  options: Parameters<typeof linkOptions<TOptions, TRouter>>[0],
): InternalLink {
  return linkOptions(options) as InternalLink
}

export type InternalLinkDestination = NonNullable<InternalLink['to']>

export type Link = ExternalLink | InternalLink
